<div class="md-container">
    <p-table
        #table
        [value]="lsProvincia"
        [rows]="4"
        styleClass="font-size: 10px; p-datatable-sm;"
        [showCurrentPageReport]="true"
        scrollDirection="both"
        selectionMode="single" 
    >
        <ng-template pTemplate="header" let-columns>
            <tr class="header-table">
            </tr>
            <tr>
                <th scope="col" [hidden]="true">

                </th>
                <th *ngIf="!loading" scope="col">
                    <div class="p-inputgroup" style="display: flex; width: 100%;">
                        <input #filterInput pInputText type="text" placeholder="Seleccione opción" (input)="table.filter(filterInput.value, 'Nombre', 'contains')" style="flex: 1 1 auto; border-top-right-radius: 0; border-bottom-right-radius: 0;" />
                        <button type="button" pButton icon="bx bx-search" style="background-color: var(--color-primario); border-color: var(--color-primario); color: white; border-top-left-radius: 0; border-bottom-left-radius: 0;"></button>
                    </div>
                </th>
                <p-skeleton *ngIf="loading" height="1rem" styleClass="mb-2 sheleton-header-2"></p-skeleton>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dataProvincia let-rowIndex="rowIndex">
            <tr style="cursor: pointer;" [pSelectableRow]="dataProvincia" (click)="onRowDblClick($event, dataProvincia)">
                <td [hidden] = "true">
                    {{dataProvincia.Id}}
                </td>
                <td class="center">
                    {{dataProvincia.Nombre | uppercase}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading">
                <td colspan="3">No existen registros.</td>
            </tr>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
        </ng-template>
    </p-table>
</div>